<template>
  <v-dialog v-if="dialogOpen" v-model="dialogOpen" persistent max-width="720px">
    <v-card ref="cardScroll">
      <v-card-title>
        <span class="text-h5">{{ dataItem.schema_label }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="handleClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-2">
        <v-form ref="form" lazy-validation>
          <v-row class="ma-0">
            <SurveyAnswerPage
              ref="refSurveyAnswer"
              :isUseIFrame="false"
              :propSchema="dataItem.schema"
              :propSchemaDetail="dataItem.schema_detail"
              :propUseButtonSubmit="false"
            />
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions style="justify-content: center">
        <v-spacer></v-spacer>
        <v-btn class="ma-2" color="info" @click="handleSubmit">{{
          $t("submit")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
  
<script>
import _ from "lodash";
import SurveyAnswerPage from "../../views/Customer/SurveyJS/SurveyAnswerPage.vue";

export default {
  inject: ["isAppLoading"],
  props: {
    dialogOpen: { default: false },
    editedItem: {
      default: () => ({
        schema_label: null,
        schema: null,
        schema_detail: null,
      }),
    },
  },
  emits: ["onSave", "onClose"],
  components: {
    SurveyAnswerPage,
  },
  data() {
    return {
      dataItem: {
        schema_label: null,
        schema: null,
        schema_detail: null,
      },
    };
  },
  created() {},
  methods: {
    handleClose() {
      this.$emit("onClose");
    },
    async handleSubmit() {
      let validateSchema = false;
      if (this.$refs.refSurveyAnswer) {
        const schema_detail = await this.$refs.refSurveyAnswer.handleSubmit();
        this.dataItem.schema_detail = schema_detail;
        if (!schema_detail) {
          validateSchema = true;
        }
      }
      if (validateSchema) {
        const card = this.$refs.cardScroll;
        card.$el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      // ========== ========== ========== ==========
      this.$emit("onSave", this.dataItem);
    },
  },
  computed: {},
  filters: {},
  watch: {
    dialogOpen: {
      handler() {
        if (this.dialogOpen) {
          let data = _.cloneDeep(this.editedItem);
          this.dataItem = { ...data };
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
  
<style scoped>
</style>